module.exports = __webpack_public_path__ + "03_bob_black.e7e9d401.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_bob_black.png
// module id = DBx8
// module chunks = 0